import React, { Component } from 'react'
import { Link, useParams } from 'react-router-dom'
import moment from 'moment'

import Resource from '../Resource'

import '../styles/UserActivityContainer.css'

const ActivityItem = {
  watched: ({ value, videos }) =>
    `Watched video ${(videos.find((v) => v.id / 1 === value / 1) || {}).title}`,
  'launched-app': () => `Opened the EL-FIT App`,
  'page-view': ({ value }) => `Viewed ${value}`,
}

const formatTime = (min) => {
  if (min > 60) {
    return `${Math.floor(min / 60)}h ${min % 60}m`
  }
  return `${min}m`
}

const UserActivityContainer = (props) => {
  const { id } = useParams()
  return (
    <Resource collection path={['videos']} placeholder={[]}>
      {(videos) => (
        <Resource path={['users', id / 1]} placeholder={[]}>
          {(user, { onUpdate, NestedResource }) => (
            <div id="UserActivityContainer">
              <Link to="/users">&lt; Back</Link>
              <h3 className="tab-header">{user.username}</h3>
              <div className="row" style={{ marginTop: 30 }}>
                <div className="col-md-4 activity">
                  <h5 className="tab-header">Recent Activity</h5>
                  <NestedResource path={['activity']} placeholder={[]}>
                    {(activity) =>
                      activity
                        .map((a) => {
                          const Component = ActivityItem[a.type]
                          return (
                            <div className="activity-item">
                              <Component {...a} videos={videos} />
                              <div className="timestamp">{moment(a.createdAt).fromNow()}</div>
                            </div>
                          )
                        })
                        .reverse()
                    }
                  </NestedResource>
                </div>
                <div className="col-md-4 activity">
                  <h5 className="tab-header">Recent Fitness Data</h5>
                  <NestedResource path={['fitness-data']} placeholder={[]}>
                    {(data) =>
                      data
                        .map((a) => {
                          return (
                            <div className="fitness-item">
                              <div style={{ display: 'flex' }}>
                                <span className="label">Activity levels:</span>
                                <div className="activity-levels">
                                  <div style={{ flex: 1 }} />
                                  {a.data.summary.activityLevels.map((a) => (
                                    <div
                                      className={a.name}
                                      title={`${a.name} for ${formatTime(a.minutes)}`}
                                      style={{ width: `${(a.minutes / 1440) * 100}%` }}
                                    />
                                  ))}
                                </div>
                              </div>
                              <div>
                                <span className="label">Steps:</span> {a.steps.toLocaleString()}
                              </div>
                              <div>
                                <span className="label">Calories:</span>{' '}
                                {a.data.summary.calories.total.toLocaleString()} (BMR:{' '}
                                {a.data.summary.calories.bmr.toLocaleString()})
                              </div>
                              <div>
                                <span className="label">Date:</span> {a.date}
                              </div>
                            </div>
                          )
                        })
                        .reverse()
                    }
                  </NestedResource>
                </div>
              </div>
            </div>
          )}
        </Resource>
      )}
    </Resource>
  )
}

export default UserActivityContainer
